module.exports = "img/flags/PF.856b112.png";